var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 98,
    viewBox: "0 0 114 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5817 0L0 98H113.163L56.5817 0Z",
    fill: "#FFC727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5816 14.1968L12.2998 90.9016H100.87L56.5816 14.1968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0991 36.3921H61.0703L60.4662 69.4615H52.7032L52.0991 36.3921Z",
    fill: "#FFC727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4601 73.6057H52.7032V81.3626H60.4601V73.6057Z",
    fill: "#FFC727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.84a50e0fb3d146c0fd69cb59a2739a9c.svg";
export { ForwardRef as ReactComponent };